var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import countries from 'i18n-iso-countries';
import enCountryCodes from 'i18n-iso-countries/langs/en.json';
import jaCountryCodes from 'i18n-iso-countries/langs/ja.json';
import koCountryCodes from 'i18n-iso-countries/langs/ko.json';
import zhCountryCodes from 'i18n-iso-countries/langs/zh.json';
import esCountryCodes from 'i18n-iso-countries/langs/es.json';
import itCountryCodes from 'i18n-iso-countries/langs/it.json';
import deCountryCodes from 'i18n-iso-countries/langs/de.json';
import frCountryCodes from 'i18n-iso-countries/langs/fr.json';
import jaYaml from '../../config/locales/ja.yml';
import enYaml from '../../config/locales/en.yml';
import koYaml from '../../config/locales/ko.yml';
import zhTWYaml from '../../config/locales/zh-TW.yml';
import esYaml from '../../config/locales/es.yml';
import itYaml from '../../config/locales/it.yml';
import deYaml from '../../config/locales/de.yml';
import frYaml from '../../config/locales/fr.yml';
import { deepCamelize } from '../utils/camelize';
import ja from './ja';
import en from './en';
import ko from './ko';
import zhTW from './zh-TW';
import es from './es';
import it from './it';
import de from './de';
import fr from './fr';
var filterNonISOCountries = function (countryNames) {
    var result = __assign({}, countryNames);
    delete result.XK; // reject XK because Kosovo is not registed in ISO data set.
    return result;
};
countries.registerLocale(enCountryCodes);
countries.registerLocale(jaCountryCodes);
countries.registerLocale(koCountryCodes);
countries.registerLocale(zhCountryCodes);
countries.registerLocale(esCountryCodes);
countries.registerLocale(itCountryCodes);
countries.registerLocale(deCountryCodes);
countries.registerLocale(frCountryCodes);
export var SupportedLanguages = [
    'ja',
    'en',
    'ko',
    'zh-TW',
    'it',
    'es',
    'de',
    'fr',
];
export var resources = {
    en: {
        translations: __assign(__assign({}, en), { countries: __assign(__assign({}, filterNonISOCountries(countries.getNames('en'))), { TW: 'Taiwan' }), params: deepCamelize(enYaml.en.activerecord.attributes) }),
    },
    ja: {
        translations: __assign(__assign({}, ja), { countries: filterNonISOCountries(countries.getNames('ja')), params: deepCamelize(jaYaml.ja.activerecord.attributes) }),
    },
    ko: {
        translations: __assign(__assign({}, ko), { countries: filterNonISOCountries(countries.getNames('ko')), params: deepCamelize(koYaml.ko.activerecord.attributes) }),
    },
    'zh-TW': {
        translations: __assign(__assign({}, zhTW), { countries: __assign(__assign({}, filterNonISOCountries(countries.getNames('zh'))), { TW: '台灣' }), params: deepCamelize(zhTWYaml['zh-TW'].activerecord.attributes) }),
    },
    it: {
        translations: __assign(__assign({}, it), { countries: filterNonISOCountries(countries.getNames('it')), params: deepCamelize(itYaml.it.activerecord.attributes) }),
    },
    es: {
        translations: __assign(__assign({}, es), { countries: filterNonISOCountries(countries.getNames('es')), params: deepCamelize(esYaml.es.activerecord.attributes) }),
    },
    de: {
        translations: __assign(__assign({}, de), { countries: filterNonISOCountries(countries.getNames('de')), params: deepCamelize(deYaml.de.activerecord.attributes) }),
    },
    fr: {
        translations: __assign(__assign({}, fr), { countries: filterNonISOCountries(countries.getNames('fr')), params: deepCamelize(frYaml.fr.activerecord.attributes) }),
    },
};
